import { useCallback } from 'react';

const PREF_KEY = 'ek_analytics_opt_out';

const hasWindow = typeof window !== 'undefined';

let analyticsEnabled = true;

if (hasWindow) {
  try {
    const stored = window.localStorage.getItem(PREF_KEY);
    if (stored === '1') {
      analyticsEnabled = false;
    }
  } catch (_) {
    // ignore storage failures
  }
}

const applyConsent = (enabled) => {
  try {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', { analytics_storage: enabled ? 'granted' : 'denied' });
    }
  } catch (_) {
    // ignore
  }
};

const getTracker = () => {
  if (!hasWindow || !analyticsEnabled) return null;
  if (typeof window.trackAnalyticsEvent === 'function') return window.trackAnalyticsEvent;
  if (typeof window.gtag === 'function') return (name, params) => window.gtag('event', name, params);
  return null;
};

export const trackEvent = (name, params = {}) => {
  if (!name || !analyticsEnabled || !hasWindow) return;
  const t = getTracker();
  if (t) t(name, params || {});
};

export const setAnalyticsEnabled = (enabled) => {
  analyticsEnabled = !!enabled;
  if (!hasWindow) return;
  try {
    if (enabled) window.localStorage.removeItem(PREF_KEY);
    else window.localStorage.setItem(PREF_KEY, '1');
  } catch (_) {
    // ignore storage issues
  }
  applyConsent(analyticsEnabled);
};

export const isAnalyticsEnabled = () => analyticsEnabled;

export const useTrackEvent = () => useCallback((name, params) => trackEvent(name, params), []);
